/**
 * Galerie de portraits des vignerons — Vignerons de la Cave de Pierrefeu
 * Lit un Google Sheet publié en CSV (colonnes : Prénom, Accroche,
 * Cuvée préférée, Citation, Photo, Vidéo) et affiche une grille cliquable.
 * Le clic ouvre une vidéo dans une fenêtre modale — YouTube, Vimeo, ou
 * fichier vidéo direct sont détectés automatiquement depuis le lien.
 */
(function () {
  function embedFor(url) {
    if (!url) return "";
    var yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
    if (yt) {
      return '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    }
    var vimeo = url.match(/vimeo\.com\/(\d+)/);
    if (vimeo) {
      return '<iframe src="https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    }
    return '<video src="' + url + '" controls autoplay playsinline></video>';
  }

  function init(root) {
    var sheetUrl = root.dataset.sheetUrl;
    if (!sheetUrl || typeof Papa === "undefined") return;

    Papa.parse(sheetUrl, {
      download: true,
      header: true,
      skipEmptyLines: true,
      transformHeader: function (h) { return h.replace(/^\uFEFF/, "").trim(); },
      transform: function (v) { return typeof v === "string" ? v.trim() : v; },
      complete: function (results) {
        var rows = results.data.filter(function (r) { return r["Prénom"]; });
        renderGrid(root, rows);
        setupModal(root, rows);
      }
    });
  }

  function renderGrid(root, rows) {
    var grid = root.querySelector("[data-pv-grid]");
    grid.innerHTML = rows
      .map(function (r, i) {
        var photo = r["Photo"] || "";
        return (
          '<button type="button" class="pv-card" data-pv-index="' + i + '">' +
          (photo ? '<img src="' + photo + '" alt="' + r["Prénom"] + '" loading="lazy">' : "") +
          '<div class="pv-scrim"></div>' +
          '<span class="pv-play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7Z"/></svg></span>' +
          '<div class="pv-info">' +
          '<p class="pv-name">' + r["Prénom"] + "</p>" +
          (r["Accroche"] ? '<p class="pv-tagline">' + r["Accroche"] + "</p>" : "") +
          "</div>" +
          "</button>"
        );
      })
      .join("");
  }

  function setupModal(root, rows) {
    var modal = root.querySelector("[data-pv-modal]");
    // Move the modal to the end of <body> so it isn't trapped inside a
    // parent with a CSS transform (Shopify's section/page animations),
    // which would otherwise turn "position: fixed" into a positioning
    // relative to that parent instead of the actual viewport.
    document.body.appendChild(modal);
    var videoBox = modal.querySelector("[data-pv-video]");
    var nameEl = modal.querySelector("[data-pv-name]");
    var taglineEl = modal.querySelector("[data-pv-tagline]");
    var quoteEl = modal.querySelector("[data-pv-quote]");

    function open(row) {
      videoBox.innerHTML = embedFor(row["Vidéo"]);
      nameEl.textContent = row["Prénom"] || "";
      var tagBits = [];
      if (row["Accroche"]) tagBits.push(row["Accroche"]);
      if (row["Cuvée préférée"]) tagBits.push("Cuvée préférée : " + row["Cuvée préférée"]);
      taglineEl.textContent = tagBits.join(" · ");
      quoteEl.textContent = row["Citation"] || "";
      quoteEl.style.display = row["Citation"] ? "" : "none";
      modal.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }

    function close() {
      modal.classList.remove("is-open");
      videoBox.innerHTML = "";
      document.body.style.overflow = "";
    }

    root.querySelectorAll("[data-pv-index]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        open(rows[parseInt(btn.dataset.pvIndex, 10)]);
      });
    });

    modal.querySelector("[data-pv-close]").addEventListener("click", close);
    modal.addEventListener("click", function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }

  document.querySelectorAll("[data-portraits-vignerons]").forEach(init);
})();